export default __webpack_public_path__ + "static/media/star-outline.2e27ff0b.svg";